import { Check, X } from "lucide-react";

export function InclusionsExclusions({ inclusions, exclusions }) {
  return (
    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
      <div>
        <h4 className="mb-3 font-display text-sm font-semibold text-emerald-700">Inclusions</h4>
        <ul className="space-y-2.5">
          {inclusions?.length ? inclusions.map((item, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-slate-600">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
              <span>{item}</span>
            </li>
          )) : <li className="text-sm text-slate-400">Not specified</li>}
        </ul>
      </div>
      <div>
        <h4 className="mb-3 font-display text-sm font-semibold text-red-700">Exclusions</h4>
        <ul className="space-y-2.5">
          {exclusions?.length ? exclusions.map((item, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-slate-600">
              <X className="mt-0.5 h-4 w-4 shrink-0 text-red-500" />
              <span>{item}</span>
            </li>
          )) : <li className="text-sm text-slate-400">Not specified</li>}
        </ul>
      </div>
    </div>
  );
}
